<app-side-menu (sideNavMessage$)="listenerNav($event)" [language]="language" [compact]="false"></app-side-menu>
<app-nav-bar (navMessage$)="listenerNav($event)"></app-nav-bar>
<app-footer></app-footer>
 
@if (security.permitted('sales', 'sale detail', 'view')) {
<div class="content-page bg-gray text-dark">
    <div class="content p-1">
        @if (isQuote) {
            <h5 class="px-1 text-capitalize text-dark">{{words[language]['quotes']}}</h5>
        }
        @if (!isQuote) {
            <h5 class="px-1 text-capitalize text-dark">{{words[language]['sales']}}</h5>
        }
        <div class="col-md-12 p-1">
            <div class="rounded">
                <div class="list-bar">
                    <form [formGroup]="form" class="form-row">
                        <div class="form-group col">
                            <div class="input-group">
                                <div class="input-group-append">
                                    <span class="input-group-text"><span class="mdi mdi-magnify search-icon"></span></span>
                                </div>
                                <input autocomplete="off" type="search" class="form-control" id="search" autofocus="true" formControlName="inquiry" />
                            </div>
                        </div>
                        @if (lots && (lots.length > 1)) {
                            <div class="form-group col">
                                <select class="form-control" name="lot" id="lot-filter" formControlName="lot">
                                    <option value="0">All {{words[language]['lots']}}</option>
                                    @for (lot of lots; track lot.id) {
                                        <option value="{{lot.id}}">{{lot.name}}</option>
                                    }
                                </select>
                            </div>
                        }
                        <div class="form-group col">
                            <select class="form-control" name="type" id="type-filter" formControlName="type">
                                <option value="">All {{isQuote ? words[language]['quotes'] : words[language]['sales']}}</option>
                                <option value="4">Buy Here - Pay Here</option>
                                <option value="1,3">Cash and outside financed</option>
                                <option value="1,3,4">All except wholesale</option>
                                <option value="2">Wholesale</option>
                            </select>
                        </div>
                        @if (!isQuote) {
                            <div class="form-group col">
                                <select class="form-control" name="status" id="status-filter" formControlName="status">
                                    <option value="0">All statuses</option>
                                    @for (status of statuses; track status) {
                                        <option [value]="status.id">{{status.name}}</option>
                                    }
                                </select>
                            </div>
                        }
                        <div class="form-group col">
                            <date-span [verb]="isQuote ? 'Quoted' : 'Sold'" [default]="FILTER_SPAN_KEY" (chosen)="spanned($event)"></date-span>
                        </div>
                    </form>
                    @if (security.permitted('sales', 'sale detail', 'add')) {
                        <div class="d-flex justify-content-end">
                            <div class="dropdown">
                                <button class="btn btn-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <span class="uil-plus"></span>
                                </button>
                                <div class="dropdown-menu">
                                    <a class="dropdown-item" (click)="createSale(this.WHOLESALE)">Wholesale</a>
                                    <a class="dropdown-item" (click)="createSale(this.CASH)">Cash</a>
                                    <a class="dropdown-item" (click)="createSale(this.OUTSIDE)">Outside</a>
                                    @if (enableBHPH) {
                                        <a class="dropdown-item" (click)="createSale(this.BHPH)">In-House (BHPH)</a>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                </div>
                <div id="listing" class="col-md-12 tableFixHead" (scroll)="scrolled($event)">
                    @if (sales) {
                        <table class="table table-sm table-hover table-striped table-responsive-sm" id="saleTable">
                            <thead>
                                <tr>
                                    <th (click)="sort('saleDate')" class="sorted" scope="col">
                                        Date
                                        @if (sortedAsc('saleDate')) {
                                            <span class="dripicons-chevron-up text-dark sort-icon"></span>
                                        }
                                        @if (sortedDesc('saleDate')) {
                                            <span class="dripicons-chevron-down text-dark sort-icon"></span>
                                        }
                                    </th>
                                    @if (isQuote) {
                                        <th scope="col">{{ words[language]['expires'] }}</th>
                                    }
                                        <th scope="col">{{ words[language]['Type'] }}</th>
                                    @if (!isQuote) {
                                        <th scope="col">{{ words[language]['Status'] }}</th>
                                    }
                                    <th scope="col">{{ words[language]['Buyer'] }}</th>
                                    <th scope="col">{{ words[language]['Year'] }} {{ words[language]['Make'] }} {{ words[language]['Model'] }}</th>
                                    <th scope="col">{{ words[language]['Stock Number'] }}</th>
                                    <th scope="col">{{ words[language]['Sale Price'] }}</th>
                                    <th class="text-right" scope="col"></th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (sale of sales; track sale.id) {
                                    <tr class="clickable text-dark">
                                        <td [routerLink]="['/', path, sale.id]">{{sale.saleDate | date:'shortDate'}}</td>
                                        @if (isQuote) {
                                            <td [routerLink]="['/', path, sale.id]"><span [class]="expiryToClass(sale.expirationDate)">{{sale.expirationDate | date:'shortDate'}}</span></td>
                                        }
                                        <td [routerLink]="['/', path, sale.id]">
                                            {{sale.type}}
                                            @if (sale.type == 'BHPH' && sale.taxMethod && (sale.taxMethod.length > 0)) {
                                                <p class="subtitle">Tax {{sale.taxMethod | titlecase}}</p>
                                            }
                                        </td>
                                        @if (!isQuote) {
                                            <td [routerLink]="['/', path, sale.id]">{{sale.status}}</td>
                                        }
                                        <td [routerLink]="['/', path, sale.id]">
                                            {{sale.buyer}}
                                            <p class="subtitle">{{sale.city | titlecase}}, {{sale.state | uppercase}}</p>
                                        </td>
                                        <td [routerLink]="['/', path, sale.id]">
                                            <div class="flex-start">
                                                @if (sale.url) {
                                                    <img [src]="sale.url" [alt]="sale.model" />
                                                }
                                                @if (!sale.url) {
                                                    <span class="pallette" [style.backgroundColor]="sale.exteriorColor ? sale.exteriorColor.toLowerCase() : ''">&nbsp;</span>
                                                }
                                                <span>{{sale.year}} {{sale.make}} {{sale.model}}</span>
                                            </div>
                                        </td>
                                        <td [routerLink]="['/', path, sale.id]">
                                            {{sale.stock}}
                                            <p class="subtitle">{{sale.vin}}</p>
                                        </td>
                                        <td [routerLink]="['/', path, sale.id]">
                                            {{sale.totalSalePrice | currency}}
                                            <p class="subtitle">{{sale.driveOutPrice | currency}}</p>
                                        </td>
                                        <!-- actions -->
                                        <td class="text-right actions">
                                            <!-- delete -->
                                            @if (security.permitted('sales', 'sale detail', 'delete')) {
                                            <button title="Delete" class="btn btn-sm btn-link" (click)="selectSale(sale)" data-target="#deleteModal" data-toggle="modal">
                                                @if (!loading) {
                                                    <span class="dripicons-trash text-danger"></span>
                                                }
                                                @if (loading) {
                                                    <span class="spinner-grow spinner-grow-sm" role="status"></span>
                                                }
                                            </button>
                                            }
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    }
                </div>
            </div>
            <p class="list-footer text-muted">{{displayed | number: '1.0-0'}} / {{records | number: '1.0-0'}}
                {{words[language]['displayed']}}</p>
        </div>
    </div>
</div>
}

<!-- loading -->
@if (loading ) {
<div class="content-page bg-gray d-flex justify-content-center align-items-center">
    <div class="spinner-grow avatar-lg text-secondary" role="status"></div>
</div>
}

<!-- delete modal -->
<div class="modal fade" id="deleteModal" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body d-flex flex-wrap align-items-center justify-content-center">
                <span class="uil-trash-alt text-danger display-1"></span>
                <h3 class="text-danger w-100 text-center">{{words[language][ 'delete' ] }}</h3>
                <span class="text-dark my-1 text-center">{{words[language][ 'deleteSale' ] }}</span>
                <button class="btn btn-danger mt-2" (click)="delete()" [disabled]="loading">
                    @if (loading) {
                    <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
                    }
                    {{words[language][ 'yes' ] }}</button>
                <button class="btn btn-secondary mt-2 ml-2" data-dismiss="modal" id="btn-close-modal-delete">No</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->
